export * from "./category-carousel-item";
export * from "./category-details";

import { CategoryCarouselItemComponent } from "./category-carousel-item";
import { CategoryDetailsComponent } from "./category-details";


export const CategoryAtoms = [CategoryCarouselItemComponent, CategoryDetailsComponent];